(() => {
  if (window.__KervelanSearchSortLoaded) return;
  window.__KervelanSearchSortLoaded = true;

  const collectionSelector = 'collection-component.kervelan-collection';
  const componentSelector = `${collectionSelector} sorting-filter-component`;

  const rewriteIds = (component, index) => {
    const token = `kv-search-sort-${index}`;

    const select = component.querySelector('select[name="sort_by"]');
    const selectLabel = select?.closest('.sorting-filter__container')?.querySelector('label[for]');
    if (select instanceof HTMLSelectElement) {
      select.id = `${token}-select`;
      if (selectLabel instanceof HTMLLabelElement) selectLabel.htmlFor = select.id;
    }

    const details = component.querySelector('details');
    const summary = details?.querySelector('summary');
    const listbox = details?.querySelector('[role="listbox"]');
    const title = summary?.querySelector('.facets__label');

    if (details instanceof HTMLDetailsElement) details.id = `${token}-details`;
    if (listbox instanceof HTMLElement) listbox.id = `${token}-options`;
    if (summary instanceof HTMLElement && listbox instanceof HTMLElement) {
      summary.setAttribute('aria-controls', listbox.id);
    }
    if (title instanceof HTMLElement) title.id = `${token}-label`;
    if (listbox instanceof HTMLElement && title instanceof HTMLElement) {
      listbox.setAttribute('aria-labelledby', title.id);
    }

    component.querySelectorAll('input[type="radio"][name="sort_by"]').forEach((input, optionIndex) => {
      if (!(input instanceof HTMLInputElement)) return;
      const label = input.closest('label');
      input.id = `${token}-option-${optionIndex}`;
      if (label instanceof HTMLLabelElement) label.htmlFor = input.id;
    });
  };

  const enhanceComponent = (component, index) => {
    if (!(component instanceof HTMLElement)) return;
    if (component.dataset.kvSearchSortEnhanced === 'true') return;

    component.dataset.kvSearchSortEnhanced = 'true';
    component.classList.add('kervelan-sort');

    component
      .querySelectorAll('.facets__summary .facets__label, .sorting-filter__container > .facets__label')
      .forEach((label) => {
        if (label.textContent !== 'SORT BY') label.textContent = 'SORT BY';
      });

    rewriteIds(component, index);
  };

  const enhanceAll = (root = document) => {
    if (root instanceof Element && root.matches(componentSelector)) {
      enhanceComponent(root, 0);
      return;
    }

    root.querySelectorAll?.(componentSelector).forEach((component, index) => enhanceComponent(component, index));
  };

  let observedRoot = null;

  const observer = new MutationObserver((mutations) => {
    const hasNewSortingComponent = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) => node instanceof Element && (node.matches('sorting-filter-component') || node.querySelector('sorting-filter-component'))
      )
    );

    if (hasNewSortingComponent) enhanceAll(observedRoot || document);
  });

  const bindObserver = () => {
    const nextRoot = document.querySelector(collectionSelector);
    if (!(nextRoot instanceof Element)) {
      observer.disconnect();
      observedRoot = null;
      return;
    }

    if (observedRoot === nextRoot) return;

    observer.disconnect();
    observedRoot = nextRoot;
    observer.observe(observedRoot, { childList: true, subtree: true });
  };

  const init = () => {
    enhanceAll();
    bindObserver();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    requestAnimationFrame(() => {
      enhanceAll(event.target);
      bindObserver();
    });
  });

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    init();
  });
})();
